/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Step_1Inputs */

const en_svc_n8n_step_1 = /** @type {(inputs: Svc_N8n_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map the process and agree what triggers it and what counts as done.`)
};

const lv_svc_n8n_step_1 = /** @type {(inputs: Svc_N8n_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izprotam procesu un vienojamies, kas to iedarbina un kas skaitās paveikts.`)
};

/**
* | output |
* | --- |
* | "Map the process and agree what triggers it and what counts as done." |
*
* @param {Svc_N8n_Step_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_step_1 = /** @type {((inputs?: Svc_N8n_Step_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Step_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_step_1(inputs)
	return en_svc_n8n_step_1(inputs)
});